import React from 'react';

const SkeletonText = ({
  text
}) => {
  return (
    <div className="skeleton">
      {text}
    </div>
  );
};

export default SkeletonText;
